





































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import MapMarker from '@/app/components/Field/MapMarker.vue'

@Component({
  components: {
    MapMarker
  }
})
export default class Map extends Vue {
  private basicData: {[key:string]: string|any} = this.$store.state.mapState.basicData
  private mapOption: {[key:string]: string|boolean} = {
    streetViewControl: false,
    mapTypeControl: false
  }
  private presentIcon: any = {
    url: require('@/assets/icon/present_icon.svg'),
    size: { width: 25, height: 25, f: 'px', b: 'px' },
    scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
  }

  @Prop() private mapData!: Array<{[key:string]: string|number|any}>
  @Prop() private presentLatlng!: any

  private get getMapData () {
    return this.mapData
  }
  @Watch('getMapData')
  // mapDataが1件以上あればzoomを18にする
  propMapData (newData:any) {
    if (newData.length !== 0) {
      this.basicData.zoom = 17
    }
  }

  private get getPresentPosition () {
    return this.presentLatlng
  }
  @Watch('getPresentPosition')
  changePresentPosition (latlng:any) {
    this.presentLatlng = latlng
  }

  /* computed */
  private get fieldChoiceState (): string {
    return this.$store.state.spFieldState.choiceFieldId
  }

  @Watch('fieldChoiceState')
  onIdChange (newValue: string) : void {
    let id = parseInt(newValue)

    for (var i in this.mapData) {
      if (this.mapData[i].path.length !== 0) {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].path[0]
        }
      } else {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].fieldPosition
        }
      }
    }
  }
}
